import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Code from "./Code.js";
import imagen5 from "../img/image5.jpeg";
import imagen3 from "../img/image3.jpeg";

const CardAboutMe = ({ isMobile = false }) =>
  !isMobile ? (
    <Card
      sx={{
        width: "100%",
        height: "240px",
        background: "linear-gradient(45deg, #32323e, #595a60)",
        color: "white",
        padding: 0,
      }}
    >
      <CardContent sx={{ padding: 0 }}>
        <div className="grid grid-cols-2 gap-2">
          <div className="content-center">
            <p className="text-lg text-white italic text-center ml-[20%] w-full">
              <Code />
              Maestro en Sistemas Computacionales apasionado por la tecnología y
              la programación, especializado en el desarrollo full-stack de{" "}
              <br />
              <span className="typing-animation mb-[-5px]">
                aplicaciones móviles, web y desktop
              </span>
              <Code />
            </p>
          </div>

          <div className="w-full flex ml-auto">
            <img
              src={imagen5}
              alt="profile"
              className="w-[240px] h-full object-cover md:clip-diagonal ml-auto"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  ) : (
    <>
      <p className="text-white text-[17px] font-semibold"> Acerca de mi </p>
      <Card
        sx={{
          width: "98%",
          height: "380px",
          background: "linear-gradient(45deg, #32323e, #595a60)",
          color: "white",
          padding: 0,
        }}
      >
        <CardContent sx={{ padding: 0 }}>
          <div className="h-[calc(70vh-50px)] ">
            <p className="text-sm text-white italic text-center mt-3">
              <Code />
              <br />
              Maestro en Sistemas Computacionales apasionado por la tecnología y
              la programación, especializado en el desarrollo full-stack de
              aplicaciones móviles, web y desktop
              <br />
              <Code />
            </p>

            <img
              src={imagen3}
              alt="profile"
              className="mt-2 w-[70%] h-[200px] object-cover mx-auto"
            />
          </div>
        </CardContent>
      </Card>
    </>
  );

export default CardAboutMe;
